import { IconOpenBets, IconStatement } from "app/components/Icon/Icon";
import cx from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

type Props = {
  reportType: string;
};

const ReportTabs: React.FC<Props> = ({ reportType }) => {
  const tabs = [
    {
      type: "OPENBETS",
      url: "/reports/openbets",
      labelId: "navigation-open-bets",
      icon: <IconOpenBets className="tab-icon" />,
    },
    {
      type: "STATEMENT",
      url: "/reports/statement",
      labelId: "navigation-open-statement",
      icon: <IconStatement className="tab-icon" />,
    },
  ];

  return (
    <div className="reports__finance-summary__report-tabs">
      {tabs.map((tab, index) => (
        <Link
          to={tab.url}
          className={cx("reports__finance-summary__report-tabs__tab", {
            "reports__finance-summary__report-tabs__tab--selected":
              reportType === tab.type,
          })}
          key={index}
        >
          {tab.icon}
          <FormattedMessage tagName="span" id={tab.labelId} />
        </Link>
      ))}
    </div>
  );
};

export default ReportTabs;
